import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100vh;

  position: absolute;
  top: 0;

  @media screen and (max-width: 578px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  display: grid;
  grid-template-columns: 1fr 1fr;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;

  img {
    width: 180px;
  }
`

export const Image = styled.div`
  background-image: ${({ $image }) => `url(${$image})`};
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`

export const Success = styled.div`
  margin-top: 20px;

  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  @media screen and (max-width: 578px) {
    flex-direction: column;
    padding: 0 20px;
  }

  p {
    all: unset;
    color: #0e6655;
    font-weight: bold;
  }
`

export const Error = styled.div`
  margin-top: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  @media screen and (max-width: 578px) {
    flex-direction: column;
    padding: 0 20px;
  }

  p {
    all: unset;
    color: #a93226;
    font-weight: bold;
  }
`
